module.exports = __webpack_public_path__ + "static/media/gift-icon.89f9479a.png";